import hatsApi from '@/services/hatsApi'

export default {
  getAll () {
    return hatsApi().get('/system/payment-status')
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/PaymentStatus.js